<template>
  <div class="mb-20">
    <h1 class="pl-4 md:pl-0 text-2xl md:text-3xl uppercase my-20" :class="fontThin()">{{ $t("footer.shipping") }}</h1>
    <div v-if="currentPage">
      <vue-editor v-model="currentPage.body" :disabled="true" />
    </div>
    <div v-else>
      Still no content in this page
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PagesMixin from '@/mixins/PagesMixin';
import { VueEditor } from 'vue2-editor';

export default {
  metaInfo() {
    const description = this.$t('metaDescriptions.shipping');
    return {
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  data() {
    return {
      currentPage: {},
    };
  },

  components: {
    VueEditor,
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),
  },

  watch: {
    changedLocale() {
      this.getPage();
    },
  },

  mounted() {
    this.getPage();
  },

  mixins: [PagesMixin],

  methods: {
    getPage() {
      this.getCurrentPage('sap').then(({ data }) => {
        this.currentPage = data;
      }).catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorReload')}`);
      });
    },
  },

};
</script>
